import { makeStyles, Select as MuiSelect, SelectProps } from "@material-ui/core"
import React, { FC } from "react"
import { colors } from "../../utils/theme"
import ChevronDownIcon from "./ChevronDownIcon"

const useStyles = makeStyles({
  select: {
    height: 48,
    fontSize: 16,
    "&:hover": {
      backgroundColor: colors.primary.cloud,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${colors.primary.periwinkle}`,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${colors.neutral.clay}`,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: colors.primary.periwinkle,
    },
  },
  selectRoot: {
    paddingTop: 0,
    paddingBottom: 0,
    height: 48,
    display: "flex",
    alignItems: "center",
  },
  selectSelect: {
    backgroundColor: "transparent",
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  menuPaper: {
    borderRadius: 4,
    border: "1px solid rgba(0, 0, 0, 0.1)",
    backgroundColor: colors.neutral.white,
    boxShadow:
      "0px 0px 4px rgba(54, 53, 69, 0.1), 0px 3px 12px rgba(54, 53, 69, 0.05)",
  },
})

const Select: FC<SelectProps> = ({ children, ...props }) => {
  const classes = useStyles()
  return (
    <MuiSelect
      variant="outlined"
      className={classes.select}
      classes={{
        root: classes.selectRoot,
        select: classes.selectSelect,
      }}
      MenuProps={{
        classes: {
          paper: classes.menuPaper,
        },
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      }}
      {...props}
      IconComponent={ChevronDownIcon}
    >
      {children}
    </MuiSelect>
  )
}

export default Select
